export const iconVariants = {
  default: {
    color: "lightest-grey",
  },
  focused: {
    color: "primary-light-blue",
  },
  error: {
    color: "primary-red",
  },
  warning: {
    color: "secondary-orange",
  },
  success: {
    color: "secondary-green",
  },
};

const variants = {
  error: {
    borderColor: "primary-red",
  },
  warning: {
    borderColor: "secondary-orange",
  },
  success: {
    borderColor: "secondary-green",
  },
  focused: {
    borderColor: "primary-light-blue",
    boxShadow: `0px 1px 2px 2px rgba(21, 45, 109, 0.08),
    2px 0px 8px 4px rgba(161, 194, 218, 0.24),
    1px 1px 2px 2px rgba(21, 45, 109, 0.06),
    2px 2px 4px 2px rgba(161, 194, 218, 0.06),
    0px 2px 8px 2px rgba(161, 194, 218, 0.06)`,
  },
};

export default variants;
